import { io } from 'socket.io-client'

const getSocketUrl = () => {
	if (import.meta.env?.VITE_WS_URL) {
		return import.meta.env.VITE_WS_URL
	}

	// В production или на удалённом сервере используем текущий origin
	if (process.env.NODE_ENV === 'production' || window.location.hostname !== 'localhost') {
		return window.location.origin
	}

	if (process.env.NODE_ENV === 'development') {
		return 'http://localhost:3003'
	}

	return window.location.origin
}

const socket = io(`${getSocketUrl()}/account`, {
	autoConnect: false,
	reconnection: true,
	reconnectionAttempts: 5,
	reconnectionDelay: 1000,
	timeout: 20000,
	transports: ['websocket'],
})

const notificationListeners = new Set()
const NOTIFICATION_EVENT = 'notifications:new'

socket.on(NOTIFICATION_EVENT, payload => {
	notificationListeners.forEach(listener => {
		try {
			listener(payload)
		} catch (error) {
			// noop
		}
	})
})

socket.on('account-blocked', payload => {
	const message = payload?.message || ''
	window.dispatchEvent(
		new CustomEvent('auth:blocked', {
			detail: { message },
		})
	)
	socket.disconnect()
})

function connectWithToken(token) {
	if (!token) {
		return
	}

	socket.auth = { token }
	if (!socket.connected) {
		socket.connect()
	}
}

function updateToken(token) {
	if (!token) {
		return
	}

	socket.auth = { token }
	if (socket.connected) {
		socket.disconnect()
		socket.connect()
	} else {
		socket.connect()
	}
}

function disconnect() {
	if (socket.connected) {
		socket.disconnect()
	}
}

export default {
	connectWithToken,
	updateToken,
	disconnect,
	onNotification: listener => {
		if (typeof listener !== 'function') return () => {}
		notificationListeners.add(listener)
		return () => notificationListeners.delete(listener)
	},
}
